import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BonusesSection } from '../components/BonusesSection';
import { TargetAudienceSection } from '../components/TargetAudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#0a0e27] text-slate-50 font-sans selection:bg-yellow-500/30 selection:text-yellow-200" data-id="element-289">
      <Hero data-id="element-290" />
      <ProblemSection data-id="element-291" />
      <SolutionSection data-id="element-292" />
      <BonusesSection data-id="element-293" />
      <TargetAudienceSection data-id="element-294" />
      <HowItWorksSection data-id="element-295" />
      <FAQSection data-id="element-296" />
      <PricingSection data-id="element-297" />

      <Footer data-id="element-298" />
    </main>;
}